import formatMessageForDisplay from "./formatMessageForDisplay";

const formatThreadsForDisplay = <
  T extends {
    author_doctor_id: string | null;
    author_secretary_id: string | null;
    seen_by: string[];
    timestamp: Date;
  }
>(
  threads: T[],
  now: Date,
  allUsers: { id: string; messagename: string }[],
  currentUserId: string
) => {
  return threads.map((msg) =>
    formatMessageForDisplay(msg, now, allUsers, currentUserId)
  );
};

export default formatThreadsForDisplay;
